var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconsSettings(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Icons_settings_grey",
    "data-name": "Icons/settings_grey",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 15.001,
    height: 15.001,
    viewBox: "0 0 15.001 15.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path81",
    d: "M0-682.665H15v15H0Z",
    transform: "translate(0 682.665)",
    fill: "#868687"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g77",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g79",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g85",
    transform: "translate(0.818 0.586)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path87",
    d: "M-297.438-205.167a2.3,2.3,0,0,0-2.3,2.3,2.3,2.3,0,0,0,2.3,2.3,2.3,2.3,0,0,0,2.3-2.3A2.3,2.3,0,0,0-297.438-205.167Zm6.469.66-.624.514a1.465,1.465,0,0,0,0,2.262l.624.514a.586.586,0,0,1,.135.745l-1.232,2.134a.586.586,0,0,1-.713.256l-.757-.284a1.465,1.465,0,0,0-1.959,1.131l-.133.8a.586.586,0,0,1-.578.49h-2.465a.586.586,0,0,1-.578-.49l-.133-.8a1.465,1.465,0,0,0-1.959-1.131l-.757.284a.586.586,0,0,1-.713-.256l-1.232-2.134a.586.586,0,0,1,.135-.745l.624-.514a1.465,1.465,0,0,0,0-2.262l-.624-.514a.586.586,0,0,1-.135-.745l1.232-2.134a.586.586,0,0,1,.713-.256l.757.284a1.465,1.465,0,0,0,1.959-1.131l.133-.8a.586.586,0,0,1,.578-.49h2.465a.586.586,0,0,1,.578.49l.133.8a1.465,1.465,0,0,0,1.959,1.131l.757-.284a.586.586,0,0,1,.713.256l1.232,2.134A.586.586,0,0,1-290.969-204.507Z",
    transform: "translate(304.121 209.777)",
    fill: "none",
    stroke: "#868687",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 1
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSettings);
export default __webpack_public_path__ + "static/media/icons_settings.53a1442d3494a9d667ceac75456741c5.svg";
export { ForwardRef as ReactComponent };